import { afterRender, ChangeDetectionStrategy, Component, inject, OnInit, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { AuthStore } from './store/auth.store';
import { ToastModule } from 'primeng/toast';
import { LookupsStore } from './store/lookups.store';
import { LoadingSpinnerComponent } from "./components/layouts/loading-spinner/loading-spinner.component";
import { PlatformService } from './services/platform/platform.service';
import { AppResumeSyncService } from './services/app-resume-sync/app-resume-sync.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, ToastModule, LoadingSpinnerComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent implements OnInit {
  authStore = inject(AuthStore);
  lookupsStore = inject(LookupsStore);
  title = 'lokinter';
  contentLoading = signal(true);
  platform = inject(PlatformService)
  appResumeSync = inject(AppResumeSyncService)

  constructor() {
    afterRender(() => {
      setTimeout(() => { this.contentLoading.set(false) }, 2000)
    })
  }

  ngOnInit(): void {
    this.authStore.getUserFromLocal();
    this.appResumeSync.start();
    this.lookupsStore.getAllSettings();
  }
}
